import { IMode, IModeValue } from './types';

export const Mode: Record<IMode, IModeValue> = {
  Expanded: 'expanded',
  Collapsed: 'collapsed',
  Hidden: 'hidden',
};
